import { render, staticRenderFns } from "./TouchpointStatistics.vue?vue&type=template&id=bbfb13f4&scoped=true&"
import script from "./TouchpointStatistics.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatistics.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics.scss?vue&type=style&index=0&id=bbfb13f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfb13f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfb13f4')) {
      api.createRecord('bbfb13f4', component.options)
    } else {
      api.reload('bbfb13f4', component.options)
    }
    module.hot.accept("./TouchpointStatistics.vue?vue&type=template&id=bbfb13f4&scoped=true&", function () {
      api.rerender('bbfb13f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatistics.vue"
export default component.exports